export const useIdentStore = defineStore('ident', {
  state: () => ({
    identMethod: null as IdentMethod | null,
  }),
  actions: {
    async checkIsIdentificationCovered(data: { srId?: string; legislation?: Legislation }) {
      const { identificationRepository: identRepo, directIdentificationRepository: directIdentRepo } = useLegacyApi()

      const { password, isDirectSign } = useDirectSignStore()
      const { isCovered } = isDirectSign
        ? await directIdentRepo.getCoverageInfo(data.srId ?? password)
        : await identRepo.getCoverageInfo(data.srId, data.legislation)

      return isCovered
    },
    async getIdentMethod(srId: string, sid: string): Promise<IdentMethod> {
      const { identificationRepository: identRepo, directIdentificationRepository: directIdentRepo } = useLegacyApi()

      const identMethod = useDirectSignStore().isDirectSign
        ? await directIdentRepo.getIdentMethod(srId, sid)
        : await identRepo.getIdentMethod(srId, sid)
      this.identMethod = identMethod
      return identMethod
    },
  },
})
